import { render, staticRenderFns } from "./agenda.vue?vue&type=template&id=094596f7&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094596f7",
  null
  
)

export default component.exports